import { getHumanizationDatabase } from "./humanizationDatabase";

function pickRandom(list, random) {
  return list[Math.floor(random() * list.length)];
}

function withEndFiller(sentence, filler) {
  const match = sentence.match(/^(.*?)([.!?])$/);
  if (!match) {
    return `${sentence}, ${filler}`;
  }

  return `${match[1]}, ${filler}${match[2]}`;
}

export function insertFiller(sentence, random, probability = 0.2) {
  if (!sentence || random() >= probability) {
    return sentence;
  }

  const trimmed = sentence.trim();
  const words = trimmed.split(/\s+/);
  const { fillers } = getHumanizationDatabase();
  const startWeight = words.length > 6 ? 0.35 : 0.65;
  const middleWeight = words.length > 6 ? 0.4 : 0.15;
  const roll = random();

  if (roll < startWeight) {
    return `${pickRandom(fillers.sentenceStart, random)}, ${trimmed}`;
  }

  if (roll < startWeight + middleWeight && words.length > 4) {
    const index = Math.min(words.length - 2, Math.max(2, Math.floor(random() * words.length)));
    words.splice(index, 0, `${pickRandom(fillers.middle, random)},`);
    return words.join(" ");
  }

  return withEndFiller(trimmed, pickRandom(fillers.sentenceEnd, random));
}
